//#region recipes/cards/ivr_node/ivr_node_constants.js
var e = "promptmenu", t = "promptcollect", n = "promptplay", r = "gotoexpert", i = "branch", a = "goto", o = "assign", s = "customerdata", c = "transfer", l = "hangup", u = {
	[e]: "keypad",
	[t]: "dialer",
	[n]: "volume-2",
	[r]: "expert-node",
	[i]: "branch",
	[a]: "call-merge",
	[o]: "chevrons-right",
	[s]: "list-bullet",
	[c]: "transfer",
	[l]: "phone-hang-up"
}, d = {
	[e]: "Menu",
	[t]: "Collect",
	[n]: "Play",
	[r]: "Expert",
	[i]: "Branch",
	[a]: "Go-to",
	[o]: "Assign",
	[s]: "Customer Data",
	[c]: "Transfer",
	[l]: "Hangup"
}, f = {
	PROMPT: {
		normal: "d-recipe-ivr-node-prompt",
		selected: "d-recipe-ivr-node-prompt--selected"
	},
	LOGIC: {
		normal: "d-recipe-ivr-node-logic",
		selected: "d-recipe-ivr-node-logic--selected"
	},
	TERMINAL: {
		normal: "d-recipe-ivr-node-terminal",
		selected: "d-recipe-ivr-node-terminal--selected"
	}
}, p = {
	[e]: f.PROMPT,
	[t]: f.PROMPT,
	[n]: f.PROMPT,
	[r]: f.LOGIC,
	[i]: f.LOGIC,
	[a]: f.LOGIC,
	[o]: f.LOGIC,
	[s]: f.LOGIC,
	[c]: f.TERMINAL,
	[l]: f.TERMINAL
};
//#endregion
export { o as IVR_NODE_ASSIGN, i as IVR_NODE_BRANCH, p as IVR_NODE_CLASS_MAPPING, s as IVR_NODE_CUSTOMER_DATA, r as IVR_NODE_EXPERT, a as IVR_NODE_GO_TO, l as IVR_NODE_HANGUP, u as IVR_NODE_ICON_TYPES, d as IVR_NODE_LABELS, t as IVR_NODE_PROMPT_COLLECT, e as IVR_NODE_PROMPT_MENU, n as IVR_NODE_PROMPT_PLAY, c as IVR_NODE_TRANSFER };

//# sourceMappingURL=ivr-node-constants.js.map